<template>
  <div v-if="Object.keys(selectedParticipant).length !== 0" class="custom-mobile-overflow">
    <div class="custom-table-responsive">
      <table class="custom-table" style="width: 100%">
        <thead>
          <tr>
            <th class="pb-2">Personal</th>
            <th class="pb-2">Highest Degree</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="50%">
              <tr>
                <td><div class="text-muted regular-16">Name</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.name)">
                      {{ selectedParticipant.person.name }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><div class="text-muted regular-16">URL</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div v-if="checkNullAndEmptyValues(selectedParticipant.person.url)" class="regular-16 ml-2">
                    <a :href="selectedParticipant.person.url" style="word-break: break-all">
                      {{ selectedParticipant.person.url }}
                    </a>
                  </div>
                  <div v-else class="regular-16 ml-2"> -- </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">Email</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div v-if="checkNullAndEmptyValues(selectedParticipant.person.email)" class="regular-16 ml-2">
                    <a :href="`mailto:${selectedParticipant.person.email}`">
                      {{ selectedParticipant.person.email }}
                    </a>
                  </div>
                  <div v-else class="regular-16 ml-2"> -- </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">Gender</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.gender)">
                      {{ selectedParticipant.person.gender }}
                      <span v-if="selectedParticipant.person.gender_explanation_text">
                        {{ selectedParticipant.person.gender_explanation_text }}
                      </span>
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><div class="text-muted regular-16">Ethnicity</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.ethnicity)">
                      {{ selectedParticipant.person.ethnicity }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><div class="text-muted regular-16">Race</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div v-if="selectedParticipant.person.race.length > 0" class="ml-2">
                    <span v-for="(races, racesKey) in selectedParticipant.person.race" :key="racesKey" class="regular-16">
                      {{ races }}<span v-if="racesKey < selectedParticipant.person.race.length - 1">,</span>
                    </span>
                  </div>
                  <div v-else class="regular-16 ml-2"> -- </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">Citizenship</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div v-if="selectedParticipant.person.citizenship" class="ml-2">
                    <span v-for="(citizenship, citizenshipKey) in selectedParticipant.person.citizenship" :key="citizenshipKey" class="regular-16">
                      {{ citizenship }}<span v-if="citizenshipKey < selectedParticipant.person.citizenship.length - 1">,</span>
                    </span>
                  </div>
                  <div v-else class="regular-16 ml-2"> -- </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">
                    Field of Expertise
                  </div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16">
                    <div v-if="selectedParticipant.person.research_interest" class="ml-2">
                      <span v-for="(research, researchKey) in selectedParticipant.person.research_interest" :key="researchKey" class="regular-16">
                        {{ research }}<span v-if="researchKey < selectedParticipant.person.research_interest.length - 1">,</span>
                      </span>
                    </div>
                    <div v-else class="regular-16 ml-2"> -- </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">
                    Attendance Type
                  </div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.attendance_type)">
                      {{ selectedParticipant.person.attendance_type }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><div class="text-muted regular-16">Employment Type</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.employment_type)">
                      {{ selectedParticipant.person.employment_type }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><div class="text-muted regular-16">Tenure Status</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.tenure_status)">
                      {{ selectedParticipant.person.tenure_status }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
            </td>
            <td width="50%">
              <tr>
                <td>
                  <div class="text-muted regular-16">Degree</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.highest_degree)">
                      {{ selectedParticipant.person.highest_degree }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr v-if="checkNullAndEmptyValues(selectedParticipant.person.habilitation_year)">
                <td>
                  <div class="text-muted regular-16">Habilitation Year</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.habilitation_year)">
                      {{ selectedParticipant.person.habilitation_year }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr v-if="checkNullAndEmptyValues(selectedParticipant.person.phd_year)">
                <td>
                  <div class="text-muted regular-16">PhD Year</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.phd_year)">
                      {{ selectedParticipant.person.phd_year }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">Institution</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.highest_degree_institution_name)">
                      {{ selectedParticipant.person.highest_degree_institution_name }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">Department</div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.highest_degree_department)">
                      {{ selectedParticipant.person.highest_degree_department }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="text-muted regular-16">
                    School/Center/Other
                  </div>
                </td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.school_center_or_other)">
                      {{ selectedParticipant.person.school_center_or_other }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><div class="text-muted regular-16">Year</div></td>
                <td><div class="text-muted regular-16">:</div></td>
                <td>
                  <div class="regular-16 ml-2">
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.year)">
                      {{ selectedParticipant.person.year }}
                    </span>
                    <span v-else> -- </span>
                  </div>
                </td>
              </tr>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr>
    <div class="custom-table-responsive">
      <table class="custom-table" style="width: 100%">
        <thead>
          <tr>
            <th class="pb-2">Preferred Mailing Address</th>
            <th class="pb-2">Home Institution</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="50%">
              <tr>
                <td>
                  <div v-if="checkNullAndEmptyValues(selectedParticipant.person.preferred_address)">
                    <address-table-section :address-fields="preferredMailingAddress" />
                  <!-- <span class="px-2 badge badge-pill badge-secondary" v-if="checkNullAndEmptyValues(selectedParticipant.person.preferred_address.address_type)">
                    <span class="regular-16 typo-color-white">
                      {{ selectedParticipant.person.preferred_address.address_type }}
                    </span>
                  </span>
                  <span class="regular-16" v-if="checkNullAndEmptyValues(selectedParticipant.person.preferred_address.institution_name)">
                    {{ selectedParticipant.person.preferred_address.institution_name }},
                    {{ selectedParticipant.person.preferred_address.institution_department }}
                  </span>
                  <span class="regular-16">
                    {{ selectedParticipant.person.preferred_address.street1 }},
                    <span v-if="checkNullAndEmptyValues(selectedParticipant.person.preferred_address.street2)">
                      {{ selectedParticipant.person.preferred_address.street2 }},
                    </span>
                    {{ selectedParticipant.person.preferred_address.city }}
                  </span> -->
                  </div>
                  <div v-else>
                    <span class="regular-14 text-muted"> No data found </span>
                  </div>
                </td>
              </tr>
            </td>
            <td width="50%">
              <div v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution)">
                <tr>
                  <td>
                    <div class="text-muted regular-16">Institution</div>
                  </td>
                  <td><div class="text-muted regular-16">:</div></td>
                  <td>
                    <div class="regular-16 ml-2">
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.name)">
                        {{ selectedParticipant.person.home_institution.name }}
                      </span>
                      <span v-else> -- </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="text-muted regular-16">Department</div>
                  </td>
                  <td><div class="text-muted regular-16">:</div></td>
                  <td>
                    <div class="regular-16 ml-2">
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.department)">
                        {{ selectedParticipant.person.home_institution.department }}
                      </span>
                      <span v-else> -- </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="text-muted regular-16">
                      School/Center/Other
                    </div>
                  </td>
                  <td><div class="text-muted regular-16">:</div></td>
                  <td>
                    <div class="regular-16 ml-2">
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.subdepartment)">
                        {{ selectedParticipant.person.home_institution.subdepartment }}
                      </span>
                      <span v-else> -- </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="text-muted regular-16">Address</div>
                  </td>
                  <td><div class="text-muted regular-16">:</div></td>
                  <td>
                    <div class="regular-16 ml-2">
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.street)">
                        {{ selectedParticipant.person.home_institution.street }},
                      </span>
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.city)">
                        {{ selectedParticipant.person.home_institution.city }},
                      </span>
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.country)">
                        {{ selectedParticipant.person.home_institution.country }}
                      </span>
                      <span v-if="!checkNullAndEmptyValues(selectedParticipant.person.home_institution.street) && !checkNullAndEmptyValues(selectedParticipant.person.home_institution.city) && !checkNullAndEmptyValues(selectedParticipant.person.home_institution.country)">
                        --
                      </span>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                  <td>
                    <div class="text-muted regular-16">Position</div>
                  </td>
                  <td><div class="text-muted regular-16">:</div></td>
                  <td>
                    <div class="regular-16 ml-2">
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.position)">
                        {{ selectedParticipant.person.position }}
                      </span>
                      <span v-else> -- </span>
                    </div>
                  </td>
                </tr> -->
                <tr>
                  <td>
                    <div class="text-muted regular-16">Title</div>
                  </td>
                  <td><div class="text-muted regular-16">:</div></td>
                  <td>
                    <div class="regular-16 ml-2">
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.title)">
                        {{ selectedParticipant.person.title }},
                      </span>
                      <span v-if="checkNullAndEmptyValues(selectedParticipant.person.home_institution.title_other)">
                        {{ selectedParticipant.person.home_institution.title_other }}
                      </span>
                      <span v-if="!checkNullAndEmptyValues(selectedParticipant.person.title) && !checkNullAndEmptyValues(selectedParticipant.person.home_institution.title_other)"> -- </span>
                    </div>
                  </td>
                </tr>
              </div>
              <div v-else>
                <span class="regular-14 text-muted text-center"> No data found </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr>
    <table class="custom-table" style="width: 100%">
      <thead>
        <tr>
          <th class="pb-2">Fundings</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td width="50%">
            <tr>
              <td>
                <div class="text-muted regular-16">Funding</div>
              </td>
              <td><div class="text-muted regular-16">:</div></td>
              <td>
                <div class="regular-16 ml-2">
                  {{ checkBoolean(selectedParticipant.funding) }}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-muted regular-16">Lodging</div>
              </td>
              <td><div class="text-muted regular-16">:</div></td>
              <td>
                <div class="regular-16 ml-2">
                  {{ checkBoolean(selectedParticipant.funding_lodging) }}
                </div>
              </td>
            </tr>
            <tr>
              <td><div class="text-muted regular-16">Travel</div></td>
              <td><div class="text-muted regular-16">:</div></td>
              <td>
                <div class="regular-16 ml-2">
                  {{ checkBoolean(selectedParticipant.funding_travel) }}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-muted regular-16">
                  Statement Of Purpose
                </div>
              </td>
              <td><div class="text-muted regular-16">:</div></td>
              <td>
                <div v-if="checkNullAndEmptyValues(selectedParticipant.statement_of_purpose)" class="regular-16 ml-2">
                  <span v-html="selectedParticipant.statement_of_purpose" />
                </div>
                <div v-else class="regular-16 ml-2"> -- </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-muted regular-16">CV/Resume</div>
              </td>
              <td><div class="text-muted regular-16">:</div></td>
              <td>
                <div v-if="checkNullAndEmptyValues(selectedParticipant.download_url)" class="ml-2">
                  <a :href="selectedParticipant.download_url" target="_blank">
                    <i class="fa fa-download" /> {{ selectedParticipant.asset_file_name }}
                  </a>
                </div>
                <div v-else class="regular-16 ml-2"> -- </div>
              </td>
            </tr>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>No Details Available</div>
</template>

<script>
import mixin from "@/utils/mixin.js"
import AddressTableSection from "@/components/CommonPages/AddressTableSection.vue"

export default {
	name: "WorkshopParticipantsTabShowSection",
	components: { AddressTableSection },
	mixins: [mixin],
	props: ["selectedParticipant"],
	computed: {
		preferredMailingAddress() {
			return [
				{
					label: "Address Type",
					value: this.selectedParticipant.person.preferred_address.address_type,
				},
				// {
				//   label: 'Institution Name',
				//   value: this.selectedParticipant.person.preferred_address.institution_name,
				// },
				// {
				//   label: 'Department',
				//   value: this.selectedParticipant.person.preferred_address.institution_department,
				// },
				{
					label: "Street 1",
					value: this.selectedParticipant.person.preferred_address.street1,
				},
				{
					label: "Street 2",
					value: this.selectedParticipant.person.preferred_address.street2,
				},
				{
					label: "Zip Code",
					value:
						this.selectedParticipant.person.preferred_address.zip_code ||
						this.selectedParticipant.person.preferred_address.zipcode,
				},
				{
					label: "City",
					value: this.selectedParticipant.person.preferred_address.city,
				},
				{
					label: "State",
					value: this.selectedParticipant.person.preferred_address.state,
				},
				{
					label: "Country Name",
					value: this.selectedParticipant.person.preferred_address.country,
				},
			]
		},
	},
}
</script>
